/* src/app/shared/dialog/tv-select-date-popup/tv-select-date-popup.component.scss */
.accept-button {
  background-color: #f03c64;
  border-radius: 100px;
  color: #ffffff;
}
.reject-button {
  background: #ffffff;
  border: 1px solid #244666;
  border-radius: 100px;
  color: #244666;
}
/*# sourceMappingURL=tv-select-date-popup.component.css.map */
